export default __webpack_public_path__ + "static/media/tmdb-logo.bf7f470b.svg";